import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import "../style.css";
import uuidv4 from "uuid/v4";
import { useDispatch, useSelector } from "react-redux";
import TableComplex from "../../../vapor/tableComplex";
import WithHoldingDrawerDetail from "./drawerDetail";
import { deleteWithholding, getWithholdingsList, updateWithholding } from "../../../../store/actions/precog/withholding";
import numeral from "numeral";
import { getWithHolding } from "../../../../store/actions/precog";
import SearchedAccount from "./searchedAccount";

const Withholding = ({
  docDetail,
  setModifiedDetail,
  totalTaxable
}) => {
  const dispatch = useDispatch();
  const withHoldings = useSelector(state => state.precog.withHoldings?.data?.reasons);
  const withHoldingsList = useSelector(state => state.precog.withHoldingsList?.list);
  const withHoldingsListStatus = useSelector(state => state.precog.withHoldingsList?.status);
  const bussinessInvoice = useSelector(state => state.precog.invoiceDetail.data);  
  const [docTotal, setDocTotal] = useState(0);
  const [withHoldingNew, setWithHoldingNew] = useState([]);
  const [searchedWithholdings, setSearchedWithholdings] = useState([]);
  const [withHoldingDrawer, setWithHoldingDrawer] = useState(null);
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const [currentRecord, setCurrentRecord] = useState([]);
  const [currentType, setCurrentType] = useState(null);

  useEffect(() => {
    dispatch(getWithholdingsList(docDetail.id));
    if (docDetail?.amount) {
      setDocTotal(docDetail.amount);
    }
    dispatch(getWithHolding(""));
  }, [docDetail]);

  useEffect(() => {    
    // Calcola il totale sulle reason. Giusto? sbagliato?
    if (withHoldings) {
      let withholdingsNew = [];
      withHoldings.map(el => {
        let baseTotal = (docTotal * el.baseTaxableAmount) / 100;
        let rateTotal = (baseTotal * el.withholdingRate) / 100;
        withholdingsNew.push({
          ...el,
          baseTotal: baseTotal,
          rateTotal: rateTotal,
          reasonId: el.code,          
          title: el.description
        });
        return null;
      });
      setSearchedWithholdings(withholdingsNew);
    }
  }, [docDetail, withHoldings]);

  useEffect(() => {
    
    if (!withHoldingsList) return;
    
    setWithHoldingNew(withHoldingsList);
    /* if (docTotal && withHoldingsList) {
      let items = [];
      withHoldingsList.map(el => {
        let baseTotal = (docTotal * el.baseTaxableAmount) / 100;
        let rateTotal = (baseTotal * el.withholdingRate) / 100;
        return items.push({
          ...el,
          baseTotal: baseTotal,
          rateTotal: rateTotal,
          reasonId: el.reasonId,
          title: el.description
        });
      });
      setWithHoldingNew(items);
    }*/
  }, [docTotal, withHoldingsList]);

  const buildDataSource = () => {
    
    return withHoldingNew?.map((withholding, key) =>
      renderTableRow(withholding, key));
  };

  const getWithHoldingTotal = (types) => {
    let totalAmount = 0;
    Object.keys(types).map(el => {
      totalAmount = totalAmount + types[el].amount;
    });
    return <div>{`${numeral(Math.abs(totalAmount)).format("0,0.00")}€`}</div>;
  };

  const renderTableRow = (withholding) => {
    return {
      key: withholding.uuid,
      withholding: withholding,
      causale: (
        <div style={{ display: "flex", alignItems: "center" }}>
          {Object.keys(withholding.types).length === 1 && 
          (Object.keys(withholding.types)[0] !== "IRPEF" && Object.keys(withholding.types)[0] !== "INPS") ? 
            <div style={{padding: "0px 11px"}}> - </div> : 
            <SearchedAccount
              searchedWithholdings={searchedWithholdings}
              withholding={withholding}
              withHoldingNew={withHoldingNew}
              setWithHoldingNew={setWithHoldingNew}
              docTotal={docTotal}
              docDetail={docDetail}
              totalTaxable={totalTaxable}
            />}
          {Object.keys(withholding.types).length > 1 && <FontAwesomeIcon 
            className="withholding-expand-icon" 
            icon={["far", currentRecord[0] === withholding.uuid ? "angle-up" : "angle-down"]} 
            onClick={() => currentRecord[0] === withholding.uuid ? setCurrentRecord([]) : setCurrentRecord([withholding.uuid])} 
          />}
        </div>
      ),
      type: Object.keys(withholding.types).length === 1 && (
        <div>
          {Object.keys(withholding.types)[0] === "OTHER" ? "Altri contributi previdenziali" : Object.keys(withholding.types)[0]}
        </div>
      ),
      causaleModello: <div>{withholding.cuReason}</div>,
      contributo: (
        <NumberFormat
          allowLeadingZeros={true}
          displayType={"input"}
          thousandSeparator={"."}
          decimalSeparator={","}
          className="withholding-input-number"
          placeholder="0"
          suffix={" €"}
          onBlur={(e) => {
            
            const currentWithold = withHoldingNew.find(el => el.uuid === withholding.uuid);
            dispatch(updateWithholding(
              docDetail.id, withholding.uuid, {
                reasonId: withholding.reasonId,
                cashContribution: currentWithold.cashContribution,
                totalNetAmount: totalTaxable,
                notIncomeAmount: withholding.notIncomeAmount
              }
            ));
          }}
          onValueChange={el => {
            const currentWithold = withHoldingNew.find(el => el.uuid === withholding.uuid);
            currentWithold.cashContribution = el.floatValue;
          }}
          value={numeral(Math.abs(withholding.cashContribution)).format("0,0.00")}
        />
      ),
      aliquota: (
        Object.keys(withholding.types).length === 1 &&
        <NumberFormat
          displayType={"input"}
          thousandSeparator={"."}
          decimalSeparator={","}
          className="withholding-input-number"
          placeholder="0"
          disabled={true}
          suffix={" %"}
          value={Object.values(withholding.types)[0].withholdingRate}
        />
      ),

      ritenuta: (
        Object.keys(withholding.types).length > 1 ? getWithHoldingTotal(withholding.types) :
          <NumberFormat
            displayType={"input"}
            thousandSeparator={"."}
            decimalSeparator={","}
            className="withholding-input-number"
            placeholder="0"
            suffix={" €"}
            value={numeral(Math.abs(Object.values(withholding.types)[0].amount)).format("0,0.00")}
            onBlur={(e) => {            
              const currentWithold = withHoldingNew.find(el => el.uuid === withholding.uuid);
              dispatch(updateWithholding(
                docDetail.id, withholding.uuid, 
                {amount: currentWithold.amount, totalNetAmount: totalTaxable, type: Object.keys(withholding.types)[0], notIncomeAmount: withholding.notIncomeAmount}
              ));
            }}
            onValueChange={el => {
              const currentWithold = withHoldingNew.find(el => el.uuid === withholding.uuid);
              currentWithold.amount = el.floatValue;
            }}
          />
      ),
      removeItem: (
        bussinessInvoice.source !== "B2B" && ( <div
          onClick={() => onRemoveWithholding(withholding)}
          style={{ padding: 8 }}
        >
          <FontAwesomeIcon
            className={"preCog-detail-remove-icon"}
            icon={["far", "trash-alt"]}
          />
        </div>
        )),
      detailItem: withholding.description && Object.keys(withholding.types).length === 1 && 
        (Object.keys(withholding.types)[0] === "IRPEF" || Object.keys(withholding.types)[0] === "INPS") && (
        <div
          onClick={() => onDetailWithholding(withholding)}
          style={{ padding: 8 }}
        >
          <FontAwesomeIcon
            className={"preCog-detail-remove-icon"}
            icon={["far", "external-link-square-alt"]}
          />
        </div>
      )
    };
  };

  const withHoldingColumns = [
    {
      title: "Causale Prestazione",
      maxWidth: "38%",
      dataIndex: "causale",
      key: "causale"
    },
    {
      title: "Tipo ritenuta",
      width: "12%",
      dataIndex: "type",
      key: "type"
    },
    {
      title: "Causale per modello CU",
      width: "13%",
      dataIndex: "causaleModello",
      key: "causaleModello",
      align: "left",
      headerAlign: "left"
    },
    {
      title: "Contributo integrativo",
      width: "13%",
      dataIndex: "contributo",
      key: "contributo",
      align: "left",
      headerAlign: "left"
    },
    {
      title: "Aliquota % ritenuta",
      width: "10%",
      dataIndex: "aliquota",
      key: "aliquota"
    },
    {
      title: "Importo ritenuta",
      width: "10%",
      dataIndex: "ritenuta",
      key: "ritenuta"
    },
    {
      title: "",
      width: "4%",
      dataIndex: "removeItem",
      key: "removeItem"
    },
    {
      title: "",
      width: "2%",
      dataIndex: "detailItem",
      key: "detailItem"
    }
  ];

  const renderSummary = () => {
    let itemsRet = [
      <div key={"renderSummary"} className="conti-contabili-add" onClick={() => onAddItemClick()}>
        <FontAwesomeIcon icon={["fas", "plus-circle"]} />
      </div>
    ];

    return itemsRet;
  };

  const onAddItemClick = () => {
    let items = [];
    withHoldingNew.map(item => {
      return items.push(item);
    });
    items.push({
      reasonId: undefined,
      description: "",
      title: "",
      withholdingRate: undefined,
      baseTaxableAmount: undefined,
      amount: undefined,
      rowId: uuidv4()
    });
    setWithHoldingNew(items);
  };

  const onRemoveWithholding = withholding => {    
    let items = [];
    if (withholding.uuid) {
      withHoldingNew.map(item => {
        if (item.uuid !== withholding.uuid) {
          items.push(item);
        }
        return null;
      });
      setWithHoldingNew(items);
      dispatch(deleteWithholding(docDetail.id,
        withholding.uuid));
    } else {
      withHoldingNew.map(item => {
        if (item.rowId !== withholding.rowId) {
          items.push(item);
        }
        return null;
      });
      setWithHoldingNew(items);
    }
    
    // setModifiedDetail({ withholdings: items }); // TODO: Controllare post dei withholdings in API
  };

  const onDetailWithholding = withholdingUuid => {
    setWithHoldingDrawer(withholdingUuid);
    setVisibleDrawer(true);
  };

  return (
    <div className="conti-iva-table">
      {withHoldingDrawer && (
        <WithHoldingDrawerDetail
          withholding={withHoldingDrawer}
          draftId={docDetail.id}
          setWithHoldingDrawer={setWithHoldingDrawer}
          setVisibleDrawer={setVisibleDrawer}
          visibleDrawer={visibleDrawer}
          totalTaxable={totalTaxable}
          currentType={currentType}
        />
      )}

      <div className="withholdings-amount-container">
        <div className="withholdings-amount-text">
          Tot fattura netto IVA
        </div>
        <div className="withholdings-amount-total">
          {numeral(Math.abs(totalTaxable)).format("0,0.00")}
        </div>
      </div>
      <TableComplex
        loading={!withHoldingsListStatus || withHoldingsListStatus.started}
        summary={bussinessInvoice.source !== "B2B" && renderSummary()}
        dataSource={buildDataSource()}
        columns={withHoldingColumns}
        expandable={{
          expandedRowKeys: currentRecord,
          rowExpandable: record => Object.keys(record.withholding.types).length > 1,
          expandRowByClick: true,
          showExpandColumn: false,
          expandedRowRender: record => {
            return <>
              {Object.keys(record.withholding.types).map((el, index) =>
                <div key={index} className="withholding-type-row">
                  <div style={{paddingLeft: "4px", width: "36%"}}>
                    &nbsp;
                  </div>
                  <div style={{paddingLeft: "10px", width: "12%"}}>
                    {el === "OTHER" ? "Altri contributi previdenziali" : el}
                  </div>
                  <div style={{paddingLeft: "4px", width: "26%"}}>
                  &nbsp;
                  </div>
                  <div style={{paddingLeft: "4px", width: "10%"}}>
                    {record.withholding.types[el].withholdingRate}%
                  </div>
                  <div style={{paddingLeft: "4px", width: "14%"}}>
                    <NumberFormat
                      displayType={"input"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      className="withholding-input-number"
                      placeholder="0"
                      suffix={" €"}
                      value={numeral(Math.abs(record.withholding.types[el].amount)).format("0,0.00")}
                      onBlur={(e) => {            
                        const currentWithold = withHoldingNew.find(el => el.uuid === record.withholding.uuid);
                        dispatch(updateWithholding(
                          docDetail.id, 
                          record.withholding.uuid, 
                          {amount: currentWithold.amount, type: el}
                        ));
                      }}
                      onValueChange={el => {
                        const currentWithold = withHoldingNew.find(el => el.uuid === record.withholding.uuid);
                        currentWithold.amount = el.floatValue;
                      }}
                    />
                  </div>
                  <div style={{paddingLeft: "4px", width: "2%"}} onClick={() => {onDetailWithholding(record.withholding); setCurrentType(el);}}>
                    <FontAwesomeIcon
                      className={"preCog-detail-remove-icon"}
                      icon={["far", "external-link-square-alt"]}
                    />
                  </div>
                </div>)
              }
            </>;
          }
        }}
        // rowExpandable: record => record.name !== "Not Expandable"
      />
    </div>
  );
};

export default Withholding;
